var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":"","id":"app"}},[_c('b-row',[_c('b-col',{staticClass:"align-items-center mr-2 ml-2 pl-3 pr-3",staticStyle:{"text-align":"center"}},[_vm._v("\n      Você precisa fazer login na plataforma\n    ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }